<template>
	<div class="col-12">

		<label>Upload billede?</label>

		<div class="upload">

			<img v-if="url !== '' && !currentFile" :src="'/storage/images/'+url" alt="image upload">
			<img v-else-if="url !== ''" :src="url" alt="image upload">

			<span v-else><i class="icon--md fas fa-upload"></i> Klik for at vælge billede</span>

			<input type="file" name="file" @change="fileChange">

		</div>

	</div>
</template>

<script>
    export default {
        name: "image-upload",
		data(){
            return {
                currentFile:null,
				url:'',
			};
		},
        watch:{
            value(value){
                if(value && value !== '' && value !== null){
                    if(value instanceof Blob){
                        return;
					}
					console.log(value);
                    this.url = value;
				}
            }
        },
		methods:{
			fileChange(e){
                var files = e.target.files || e.dataTransfer.files;

                if (!files.length)
                    return;

				this.currentFile = files[0];
				this.$emit('input', files[0]);
				this.showImage(files[0]);
			},
			showImage(file){
                var reader = new FileReader();

                reader.onload = (e) => {
                    this.url = e.target.result;
                };
                reader.readAsDataURL(file);
			}
		},
        props:['value'],
    }
</script>

<style scoped>

</style>
